import React, { Component } from "react";
import {
  View,
  Text,
  Image,
  StyleSheet,
  TouchableOpacity,
  Platform,
  TextInput,
} from "react-native";
import { connect } from "react-redux";
import { MaterialCommunityIcons, FontAwesome } from "@expo/vector-icons";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useNavigation } from "@react-navigation/native";
import Lottie from "lottie-react";
import { BRANDING } from "@env";
import colors from "../../constants/colors";
import { logout } from "../../actions/login";
import { getTasks, setTaskSelected, setFormsFromAPI } from "../../actions/tasks";
import { setHeaderSearch } from "../../actions/menu";
import { getAllRecords, getAllTaskFromLog } from "../../actions/records";
import { confirmationAlert } from "../../utils";

const SEARCH_SCREENS = ["NewTask", "NewLogTask", "RecordsView"];

function getInitials(username = "") {
  if (!username) return "?";
  const local = username.includes("@") ? username.split("@")[0] : username;
  const parts = local.replace(/[._-]+/g, " ").split(" ").filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return local.slice(0, 2).toUpperCase();
}

class IqopsHeaderInner extends Component {
  state = {
    searchOpen: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.currentRoute !== this.props.currentRoute) {
      if (
        this.props.currentRoute === "MainView" ||
        !SEARCH_SCREENS.includes(this.props.currentRoute)
      ) {
        if (this.state.searchOpen) this.setState({ searchOpen: false });
        if (this.props.headerSearch) this.props.setHeaderSearch("");
      }
    }
  }

  confirmLogout = () => {
    const { dispatch, navigation } = this.props;
    confirmationAlert(
      null,
      "Are you sure you want to logout?",
      "OK",
      "Cancel",
      null,
      null,
      null,
      () => {
        dispatch(logout());
        if (Platform.OS === "web") {
          window.location.reload(false);
        } else {
          navigation.navigate("Login");
        }
      }
    );
  };

  openAccountMenu = () => {
    this.confirmLogout();
  };

  refresh = () => {
    const {
      currentRoute,
      tasksStatus,
      getTasks,
      setTaskSelected,
      setFormsFromAPI,
      getAllRecords,
      getAllTaskFromLog,
      isOnline,
    } = this.props;

    if (currentRoute === "NewTask" || currentRoute === "NewLogTask") {
      setFormsFromAPI(this.props.formsFilter);
      return;
    }
    if (currentRoute === "RecordsView") {
      if (isOnline) {
        getAllRecords({ page: 1 });
        getAllTaskFromLog({ page: 1 });
      }
      return;
    }
    if (tasksStatus === "idle") {
      getTasks();
      setTaskSelected({});
    }
  };

  toggleSearch = () => {
    const { searchOpen } = this.state;
    const next = !searchOpen;
    this.setState({ searchOpen: next });
    if (!next) {
      this.props.setHeaderSearch("");
    }
  };

  onSearchChange = (text) => {
    this.props.setHeaderSearch(text);
  };

  getPlaceholderText = () => {
    const { currentRoute } = this.props;
    var placeholderText = "";
    if (currentRoute === "NewTask") {
      placeholderText = "Search a form by name";
    } else if (currentRoute === "NewLogTask") {
      placeholderText = "Search a log by name";
    } else if (currentRoute === "RecordsView") {
      placeholderText = "Search a record by name";
    }
    return placeholderText;
  };

  render() {
    const {
      username,
      companyName,
      tasksStatus,
      formsLoaded,
      formsLoadedEnd,
      recordsLoading,
      insets,
      currentRoute,
      headerSearch,
      showBack,
      title,
      onBack,
    } = this.props;
    if (BRANDING !== "iqops") return null;

    const initials = getInitials(username);
    var refreshing = false;
    if (currentRoute == "MainView") {
      refreshing = tasksStatus === "loading";
    } else if (currentRoute == "RecordsView") {
      refreshing = recordsLoading;
    } else if (currentRoute == "NewTask" || currentRoute == "NewLogTask") {
      // Tied to setFormsFromAPI / getForms2, not login storage formsLoading.
      refreshing = !formsLoaded || !formsLoadedEnd;
    }
    const canSearch = SEARCH_SCREENS.includes(currentRoute);
    const showCompanyName = currentRoute === "MainView" && !!companyName;
    const { searchOpen } = this.state;

    return (
      <View style={[styles.safe, { paddingTop: Math.max(insets?.top || 0, 8) }]}>
        <View style={styles.row}>
          {showBack ? (
            <TouchableOpacity style={styles.backBtn} onPress={onBack} activeOpacity={0.7}>
              <MaterialCommunityIcons name="chevron-left" size={28} color={colors.primary} />
            </TouchableOpacity>
          ) : null}

          <View style={styles.logoWrap}>
            {title ? (
              <Text style={styles.titleText} numberOfLines={1}>
                {title}
              </Text>
            ) : (
              <Image
                source={require("../../../assets/iQOps-_Logo-WhiteBF.png")}
                style={styles.logo}
                resizeMode="contain"
              />
            )}
          </View>

          <View style={styles.centerWrap} pointerEvents="box-none">
            {searchOpen ? (
              <View style={styles.searchBar}>
                <TextInput
                  autoFocus
                  value={headerSearch}
                  onChangeText={this.onSearchChange}
                  placeholder={this.getPlaceholderText()}
                  placeholderTextColor="rgba(11, 77, 173, 0.5)"
                  style={styles.searchInput}
                  returnKeyType="search"
                />
                <TouchableOpacity
                  style={[styles.searchBtn, styles.searchBtnSelected]}
                  onPress={this.toggleSearch}
                  activeOpacity={0.8}
                >
                  <Image
                    source={require("../../../assets/Icons-Screens/search-selected.png")}
                    style={styles.searchIconImg}
                    resizeMode="contain"
                  />
                </TouchableOpacity>
              </View>
            ) : null}
          </View>

          <View style={styles.actions}>
            {showCompanyName ? (
              <View style={styles.companyWrap}>
                <Text style={styles.companyName} numberOfLines={1}>
                  {companyName}
                </Text>
                <MaterialCommunityIcons
                  name="chevron-down"
                  size={12}
                  color="#8a94a6"
                  style={styles.companyChevron}
                />
              </View>
            ) : null}

            {canSearch && !searchOpen ? (
              <TouchableOpacity
                style={[styles.searchBtn, styles.searchBtnUnselected]}
                onPress={this.toggleSearch}
                activeOpacity={0.8}
              >
                <Image
                  source={require("../../../assets/Icons-Screens/search-unselected.png")}
                  style={styles.searchIconImgDark}
                  resizeMode="contain"
                />
              </TouchableOpacity>
            ) : null}

            <TouchableOpacity
              style={styles.iconBtn}
              onPress={this.refresh}
              disabled={refreshing}
              activeOpacity={0.7}
            >
              {refreshing ? (
                <Lottie
                  style={styles.refreshLoader}
                  animationData={require("../animations/loading-dots-gray.json")}
                  autoPlay
                  loop
                />
              ) : (
                <FontAwesome name="refresh" size={16} color="#0b4da0" />
              )}
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.avatar}
              onPress={this.openAccountMenu}
              activeOpacity={0.7}
            >
              <Text style={styles.avatarText}>{initials}</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }
}

function IqopsHeader(props) {
  const insets = useSafeAreaInsets();
  const navigation = useNavigation();

  const onBack = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate("MainView");
    }
  };

  return (
    <IqopsHeaderInner
      {...props}
      insets={insets}
      navigation={navigation}
      currentRoute={props.currentRoute || props.route?.name}
      onBack={onBack}
    />
  );
}

const styles = StyleSheet.create({
  safe: {
    backgroundColor: "#ffffff",
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#e6eef8",
  },
  row: {
    minHeight: 52,
    paddingLeft: 16,
    paddingRight: 14,
    paddingBottom: 8,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  backBtn: {
    marginRight: 2,
    marginLeft: -6,
  },
  logoWrap: {
    alignItems: "flex-start",
    justifyContent: "center",
    flexShrink: 0,
    zIndex: 2,
  },
  logo: {
    height: 40,
    width: Math.round(40 * (581 / 239)),
  },
  titleText: {
    color: colors.primary,
    fontSize: 16,
    fontWeight: "700",
    maxWidth: 120,
  },
  centerWrap: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 6,
    minWidth: 0,
  },
  companyWrap: {
    flexDirection: "row",
    alignItems: "center",
    maxWidth: 120,
    marginRight: 8,
    flexShrink: 1,
  },
  companyName: {
    color: "#8a94a6",
    fontSize: 11,
    fontWeight: "500",
    flexShrink: 1,
  },
  companyChevron: {
    marginLeft: 1,
  },
  actions: {
    flexDirection: "row",
    alignItems: "center",
    flexShrink: 0,
    zIndex: 2,
  },
  searchBar: {
    width: "100%",
    maxWidth: 220,
    height: 34,
    borderRadius: 17,
    backgroundColor: "#d7ebfa",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: 12,
    paddingRight: 2,
  },
  searchInput: {
    flex: 1,
    height: 34,
    fontSize: 13,
    fontStyle: "italic",
    fontWeight: "500",
    color: colors.primary,
    paddingVertical: 0,
    paddingRight: 8,
  },
  searchBtn: {
    width: 33,
    height: 33,
    borderRadius: 16.5,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 6,
  },
  searchBtnUnselected: {
    backgroundColor: "#d7ebfa",
  },
  searchBtnSelected: {
    backgroundColor: "#0b4da0",
    marginRight: 0,
  },
  searchIconImg: {
    width: 16,
    height: 16,
    tintColor: "#ffffff",
  },
  searchIconImgDark: {
    width: 16,
    height: 16,
    tintColor: "#0b4da0",
  },
  iconBtn: {
    width: 33,
    height: 33,
    borderRadius: 16.5,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 8,
    backgroundColor: "#d7ebfa",
    borderWidth: 1,
    borderColor: "#ffffff",
  },
  refreshLoader: {
    width: 22,
    height: 22,
  },
  avatar: {
    width: 33,
    height: 33,
    borderRadius: 16.5,
    backgroundColor: "#d7ebfa",
    borderWidth: 1,
    borderColor: "#ffffff",
    alignItems: "center",
    justifyContent: "center",
  },
  avatarText: {
    color: "#0b4da0",
    fontSize: 12,
    fontWeight: "700",
  },
});

export default connect(
  (state) => ({
    username: state.user.get("username"),
    companyName: state.user.get("companyName") || "",
    tasksStatus: state.tasks.get("status"),
    formsLoaded: state.tasks.get("formsLoaded"),
    formsLoadedEnd: state.tasks.get("formsLoadedEnd"),
    recordsLoading: state.records.get("recordsLoading"),
    headerSearch: state.user.get("headerSearch") || "",
    formsFilter: state.tasks.get("formsFilter"),
    isOnline: true,
  }),
  (dispatch) => ({
    dispatch,
    getTasks: () => dispatch(getTasks()),
    setTaskSelected: (value) => dispatch(setTaskSelected(value)),
    setFormsFromAPI: (formsFilter) => dispatch(setFormsFromAPI(formsFilter)),
    setHeaderSearch: (value) => dispatch(setHeaderSearch(value)),
    getAllRecords: (params) => dispatch(getAllRecords(params)),
    getAllTaskFromLog: (params) => dispatch(getAllTaskFromLog(params)),
  })
)(IqopsHeader);
